import React from 'react';
import Storage from 'utils/storage';

const initialState = {
    chartsAndTableViewsConfigs: {
        hourlySalesCumuToggleState: 'chart',
        hourlySalesCumuLineChart: {
            activeDimention: 'Sales',
            allDimentions: [{ title: 'Sales', sign: '$', dollarFormat: true, showVar: 'SALES_AMT' },
            { title: 'Checks', sign: '#', dollarFormat: false, showVar: 'SALES_CNT' },
            { title: 'Guests', sign: '#', dollarFormat: false, showVar: 'GUEST_CNT' },
            { title: 'Covers', sign: '#', dollarFormat: false, showVar: 'COVER_CNT' }]
        },
        hourlySalesCumuTableView: [{ title: 'Hour', sign: null, showVar: 'HOUR_STR', sortVar: 'HOUR_NUM', sortDirection: 'default', isVisible: true },
        { title: 'Sales', sign: '$', showVar: 'SALES_AMT', sortVar: 'SALES_AMT', sortDirection: 'default', isVisible: true },
        { title: 'Guests', sign: '#', showVar: 'SALES_CNT', sortVar: 'SALES_CNT', sortDirection: 'default', isVisible: true },
        { title: 'Checks', sign: '#', showVar: 'GUEST_CNT', sortVar: 'GUEST_CNT', sortDirection: 'default', isVisible: true },
        { title: 'Covers', sign: '#', showVar: 'COVER_CNT', sortVar: 'COVER_CNT', sortDirection: 'default', isVisible: true },
        { title: 'Sales', sign: '%', showVar: 'SALES_PCT', sortVar: 'SALES_PCT', sortDirection: 'default', isVisible: false }],
        hourlySalesToggleState: 'chart',
        hourlySalesBarChart: {
            activeDimention: 'Sales',
            allDimentions: [{ title: 'Sales', sign: '$', dollarFormat: true, showVar: 'SALES_AMT' },
            { title: 'Checks', sign: '#', dollarFormat: false, showVar: 'SALES_CNT' },
            { title: 'Guests', sign: '#', dollarFormat: false, showVar: 'GUEST_CNT' },
            { title: 'Covers', sign: '#', dollarFormat: false, showVar: 'COVER_CNT' }]
        },
        hourlySalesTableView: [{ title: 'Hour', sign: null, showVar: 'HOUR_STR', sortVar: 'HOUR_NUM', sortDirection: 'default', isVisible: true },
        { title: 'Sales', sign: '$', showVar: 'SALES_AMT', sortVar: 'SALES_AMT', sortDirection: 'default', isVisible: true },
        { title: 'Guests', sign: '#', showVar: 'SALES_CNT', sortVar: 'SALES_CNT', sortDirection: 'default', isVisible: true },
        { title: 'Checks', sign: '#', showVar: 'GUEST_CNT', sortVar: 'GUEST_CNT', sortDirection: 'default', isVisible: true },
        { title: 'Covers', sign: '#', showVar: 'COVER_CNT', sortVar: 'COVER_CNT', sortDirection: 'default', isVisible: true },
        { title: 'Sales', sign: '%', showVar: 'SALES_PCT', sortVar: 'SALES_PCT', sortDirection: 'default', isVisible: false }],
        hourlyLaborToggleState: 'chart',
        hourlyLaborBarChart: {
            activeDimention: 'Labor',
            allDimentions: [{ title: 'Labor', sign: '$', dollarFormat: true, showVar: 'LABOR_AMT' },
            { title: 'Labor Hours', sign: '#', dollarFormat: false, showVar: 'LABOR_HOURS' }]
        },
        hourlyLaborTableView: [{ title: 'Hour', sign: null, showVar: 'HOUR_STR', sortVar: 'HOUR_NUM', sortDirection: 'default', isVisible: true },
        { title: 'Labor', sign: '$', showVar: 'LABOR_AMT', sortVar: 'LABOR_AMT', sortDirection: 'default', isVisible: true },
        { title: 'Labor Hours', sign: '#', showVar: 'LABOR_HOURS', sortVar: 'LABOR_HOURS', sortDirection: 'default', isVisible: true },
        { title: 'Sales', sign: '$', showVar: 'SALES_AMT', sortVar: 'SALES_AMT', sortDirection: 'default', isVisible: true },
        { title: 'Sales/Labor', sign: '$', showVar: 'SALES_AMT_PER_LABOR_AMT', sortVar: 'SALES_AMT_PER_LABOR_AMT', sortDirection: 'default', isVisible: false },
        { title: 'Sales/Labor Hours', sign: '$', showVar: 'SALES_AMT_PER_LABOR_HOURS', sortVar: 'SALES_AMT_PER_LABOR_HOURS', sortDirection: 'default', isVisible: false },
        { title: 'Labor Cost', sign: '%', showVar: 'LABOR_COST_PCT', sortVar: 'LABOR_COST_PCT', sortDirection: 'default', isVisible: false },
        { title: 'Labor', sign: '%', showVar: 'LABOR_PCT', sortVar: 'LABOR_PCT', sortDirection: 'default', isVisible: false }],
        hourlyLaborCumuToggleState: 'chart',
        hourlyLaborCumuLineChart: {
            activeDimention: 'Labor',
            allDimentions: [{ title: 'Labor', sign: '$', dollarFormat: true, showVar: 'LABOR_AMT' },
            { title: 'Labor Hours', sign: '#', dollarFormat: false, showVar: 'LABOR_HOURS' }]
        },
        hourlyLaborCumuTableView: [{ title: 'Hour', sign: null, showVar: 'HOUR_STR', sortVar: 'HOUR_NUM', sortDirection: 'default', isVisible: true },
        { title: 'Labor', sign: '$', showVar: 'LABOR_AMT', sortVar: 'LABOR_AMT', sortDirection: 'default', isVisible: true },
        { title: 'Labor Hours', sign: '#', showVar: 'LABOR_HOURS', sortVar: 'LABOR_HOURS', sortDirection: 'default', isVisible: true },
        { title: 'Sales', sign: '$', showVar: 'SALES_AMT', sortVar: 'SALES_AMT', sortDirection: 'default', isVisible: true },
        { title: 'Sales/Labor', sign: '$', showVar: 'SALES_AMT_PER_LABOR_AMT', sortVar: 'SALES_AMT_PER_LABOR_AMT', sortDirection: 'default', isVisible: false },
        { title: 'Sales/Labor Hours', sign: '$', showVar: 'SALES_AMT_PER_LABOR_HOURS', sortVar: 'SALES_AMT_PER_LABOR_HOURS', sortDirection: 'default', isVisible: false },
        { title: 'Labor Cost', sign: '%', showVar: 'LABOR_COST_PCT', sortVar: 'LABOR_COST_PCT', sortDirection: 'default', isVisible: false },
        { title: 'Labor', sign: '%', showVar: 'LABOR_PCT', sortVar: 'LABOR_PCT', sortDirection: 'default', isVisible: false }],
        costCenterToggleState: 'chart',
        costCenterBarChart: {
            activeDimention: 'Sales',
            allDimentions: [{ title: 'Sales', sign: '$', dollarFormat: true, showVar: 'SALES_AMT' },
            { title: 'Checks', sign: '#', dollarFormat: false, showVar: 'SALES_CNT' },
            { title: 'Guests', sign: '#', dollarFormat: false, showVar: 'GUEST_CNT' },
            { title: 'Covers', sign: '#', dollarFormat: false, showVar: 'COVER_CNT' }]
        },
        costCenterTableView: [{ title: 'Cost Center', sign: null, showVar: 'COST_CENTER_NAME', sortVar: 'COST_CENTER_NAME', sortDirection: 'default', isVisible: true },
        { title: 'Sales', sign: '$', showVar: 'SALES_AMT', sortVar: 'SALES_AMT', sortDirection: 'default', isVisible: true },
        { title: 'Guests', sign: '#', showVar: 'SALES_CNT', sortVar: 'SALES_CNT', sortDirection: 'default', isVisible: true },
        { title: 'Checks', sign: '#', showVar: 'GUEST_CNT', sortVar: 'GUEST_CNT', sortDirection: 'default', isVisible: true },
        { title: 'Covers', sign: '#', showVar: 'COVER_CNT', sortVar: 'COVER_CNT', sortDirection: 'default', isVisible: true },
        { title: 'Sales', sign: '%', showVar: 'SALES_PCT', sortVar: 'SALES_PCT', sortDirection: 'default', isVisible: true }],
        categorySalesToggleState: 'chart',
        categorySalesBarChart: {
            activeDimention: 'Sales',
            allDimentions: [{ title: 'Sales', sign: '$', dollarFormat: true, showVar: 'SALES_AMT' },
            { title: 'Count', sign: '#', dollarFormat: false, showVar: 'SALES_CNT' }]
        },
        categorySalesTableView: [{ title: 'Category', sign: null, showVar: 'CATEGORY_NAME', sortVar: 'CATEGORY_NAME', sortDirection: 'default', isVisible: true },
        { title: 'Sales', sign: '$', showVar: 'SALES_AMT', sortVar: 'SALES_AMT', sortDirection: 'default', isVisible: true },
        { title: 'Count', sign: '#', showVar: 'SALES_CNT', sortVar: 'SALES_CNT', sortDirection: 'default', isVisible: true },
        { title: 'Sales', sign: '%', showVar: 'SALES_PCT', sortVar: 'SALES_PCT', sortDirection: 'default', isVisible: true }]
    }
};

const loadState = () => {
    try {
        const state = {
            chartsAndTableViewsConfigs: {
                hourlySalesCumuToggleState: Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesCumuToggleState') != null ? Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesCumuToggleState') : initialState.chartsAndTableViewsConfigs.hourlySalesCumuToggleState,
                hourlySalesCumuLineChart: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesCumuLineChart') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesCumuLineChart'))) != null ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesCumuLineChart')) : initialState.chartsAndTableViewsConfigs.hourlySalesCumuLineChart,
                hourlySalesCumuTableView: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesCumuTableView') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesCumuTableView') != null)) ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesCumuTableView')) : initialState.chartsAndTableViewsConfigs.hourlySalesCumuTableView,
                hourlySalesToggleState: Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesToggleState') != null ? Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesToggleState') : initialState.chartsAndTableViewsConfigs.hourlySalesToggleState,
                hourlySalesBarChart: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesBarChart') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesBarChart'))) != null ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesBarChart')) : initialState.chartsAndTableViewsConfigs.hourlySalesBarChart,
                hourlySalesTableView: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesTableView') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesTableView') != null)) ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.hourlySalesTableView')) : initialState.chartsAndTableViewsConfigs.hourlySalesTableView,
                hourlyLaborToggleState: Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborToggleState') != null ? Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborToggleState') : initialState.chartsAndTableViewsConfigs.hourlyLaborToggleState,
                hourlyLaborBarChart: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborBarChart') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborBarChart'))) != null ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborBarChart')) : initialState.chartsAndTableViewsConfigs.hourlyLaborBarChart,
                hourlyLaborTableView: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborTableView') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborTableView') != null)) ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborTableView')) : initialState.chartsAndTableViewsConfigs.hourlyLaborTableView,
                hourlyLaborCumuToggleState: Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborCumuToggleState') != null ? Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborCumuToggleState') : initialState.chartsAndTableViewsConfigs.hourlyLaborCumuToggleState,
                hourlyLaborCumuLineChart: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborCumuLineChart') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborCumuLineChart'))) != null ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborCumuLineChart')) : initialState.chartsAndTableViewsConfigs.hourlyLaborCumuLineChart,
                hourlyLaborCumuTableView: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView') != null)) ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView')) : initialState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView,
                costCenterToggleState: Storage.getString('appState.chartsAndTableViewsConfigs.costCenterToggleState') != null ? Storage.getString('appState.chartsAndTableViewsConfigs.costCenterToggleState') : initialState.chartsAndTableViewsConfigs.costCenterToggleState,
                costCenterBarChart: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.costCenterBarChart') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.costCenterBarChart'))) != null ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.costCenterBarChart')) : initialState.chartsAndTableViewsConfigs.costCenterBarChart,
                costCenterTableView: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.costCenterTableView') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.costCenterTableView') != null)) ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.costCenterTableView')) : initialState.chartsAndTableViewsConfigs.costCenterTableView,
                categorySalesToggleState: Storage.getString('appState.chartsAndTableViewsConfigs.categorySalesToggleState') != null ? Storage.getString('appState.chartsAndTableViewsConfigs.categorySalesToggleState') : initialState.chartsAndTableViewsConfigs.categorySalesToggleState,
                categorySalesBarChart: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.categorySalesBarChart') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.categorySalesBarChart'))) != null ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.categorySalesBarChart')) : initialState.chartsAndTableViewsConfigs.categorySalesBarChart,
                categorySalesTableView: ((typeof Storage.getString('appState.chartsAndTableViewsConfigs.categorySalesTableView') != 'undefined')
                    && (Storage.getString('appState.chartsAndTableViewsConfigs.categorySalesTableView') != null)) ? JSON.parse(Storage.getString('appState.chartsAndTableViewsConfigs.categorySalesTableView')) : initialState.chartsAndTableViewsConfigs.categorySalesTableView
            }
        };
        viewsState = state;
        return state;
    } catch (ex) {
        alert(ex);
        viewsState = initialState;
        return initialState;
    }
};

function reducer(state, action) {
    switch (action.type) {
        case 'SET_SALESCUMULINECHARTTOGGLESTATE': {
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlySalesCumuToggleState', action.hourlySalesCumuToggleState);
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlySalesCumuToggleState: action.hourlySalesCumuToggleState
                }
            };
        }
        case 'SET_SALESCUMULINECHARTCONFIG': {
            state.chartsAndTableViewsConfigs.hourlySalesCumuLineChart.activeDimention = action.activeDimention;
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlySalesCumuLineChart', JSON.stringify(state.chartsAndTableViewsConfigs.hourlySalesCumuLineChart));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlySalesCumuLineChart: {
                        ...state.chartsAndTableViewsConfigs.hourlySalesCumuLineChart,
                        activeDimention: action.activeDimention
                    }
                },
            };
        }
        case 'SET_SALESCUMUTABLEVIEWCONFIG': {
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlySalesCumuTableView', JSON.stringify(action.hourlySalesCumuTableView));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlySalesCumuTableView: action.hourlySalesCumuTableView
                },
            };
        }
        case 'SET_SALESBARCHARTTOGGLESTATE': {
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlySalesToggleState', action.hourlySalesToggleState);
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlySalesToggleState: action.hourlySalesToggleState
                }
            };
        }
        case 'SET_SALESBARCHARTCONFIG': {
            state.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention = action.activeDimention;
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlySalesBarChart', JSON.stringify(state.chartsAndTableViewsConfigs.hourlySalesBarChart));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlySalesBarChart: {
                        ...state.chartsAndTableViewsConfigs.hourlySalesBarChart,
                        activeDimention: action.activeDimention
                    }
                },
            };
        }

        case 'SET_SALESTABLEVIEWCONFIG': {
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlySalesTableView', JSON.stringify(action.hourlySalesTableView));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlySalesTableView: action.hourlySalesTableView
                },
            };
        }
        case 'SET_LABORBARCHARTTOGGLESTATE': {
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlyLaborToggleState', action.hourlyLaborToggleState);
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlyLaborToggleState: action.hourlyLaborToggleState
                }
            };
        }
        case 'SET_LABORBARCHARTCONFIG': {
            state.chartsAndTableViewsConfigs.hourlyLaborBarChart.activeDimention = action.activeDimention;
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlyLaborBarChart', JSON.stringify(state.chartsAndTableViewsConfigs.hourlyLaborBarChart));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlyLaborBarChart: {
                        ...state.chartsAndTableViewsConfigs.hourlyLaborBarChart,
                        activeDimention: action.activeDimention
                    }
                },
            };
        }
        case 'SET_LABORTABLEVIEWCONFIG': {
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlyLaborTableView', JSON.stringify(action.hourlyLaborTableView));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlyLaborTableView: action.hourlyLaborTableView
                },
            };
        }
        case 'SET_LABORCUMULINECHARTTOGGLESTATE': {
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlyLaborCumuToggleState', action.hourlyLaborCumuToggleState);
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlyLaborCumuToggleState: action.hourlyLaborCumuToggleState
                }
            };
        }
        case 'SET_LABORCUMULINECHARTCONFIG': {
            state.chartsAndTableViewsConfigs.hourlyLaborCumuLineChart.activeDimention = action.activeDimention;
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlyLaborCumuLineChart', JSON.stringify(state.chartsAndTableViewsConfigs.hourlyLaborCumuLineChart));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlyLaborCumuLineChart: {
                        ...state.chartsAndTableViewsConfigs.hourlyLaborCumuLineChart,
                        activeDimention: action.activeDimention
                    }
                },
            };
        }
        case 'SET_LABORCUMUTABLEVIEWCONFIG': {
            Storage.setString('appState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView', JSON.stringify(action.hourlyLaborCumuTableView));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    hourlyLaborCumuTableView: action.hourlyLaborCumuTableView
                },
            };
        }
        case 'SET_COSTCENTERBARCHARTTOGGLESTATE': {
            Storage.setString('appState.chartsAndTableViewsConfigs.costCenterToggleState', action.costCenterToggleState);
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    costCenterToggleState: action.costCenterToggleState
                }
            };
        }
        case 'SET_COSTCENTERBARCHARTCONFIG': {
            state.chartsAndTableViewsConfigs.costCenterBarChart.activeDimention = action.activeDimention;
            Storage.setString('appState.chartsAndTableViewsConfigs.costCenterBarChart', JSON.stringify(state.chartsAndTableViewsConfigs.costCenterBarChart));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    costCenterBarChart: {
                        ...state.chartsAndTableViewsConfigs.costCenterBarChart,
                        activeDimention: action.activeDimention
                    }
                },
            };
        }

        case 'SET_COSTCENTERTABLEVIEWCONFIG': {
            Storage.setString('appState.chartsAndTableViewsConfigs.costCenterTableView', JSON.stringify(action.costCenterTableView));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    costCenterTableView: action.costCenterTableView
                },
            };
        }
        case 'SET_CATEGORYSALESBARCHARTTOGGLESTATE': {
            Storage.setString('appState.chartsAndTableViewsConfigs.categorySalesToggleState', action.categorySalesToggleState);
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    categorySalesToggleState: action.categorySalesToggleState
                }
            };
        }
        case 'SET_CATEGORYSALESBARCHARTCONFIG': {
            state.chartsAndTableViewsConfigs.categorySalesBarChart.activeDimention = action.activeDimention;
            Storage.setString('appState.chartsAndTableViewsConfigs.categorySalesBarChart', JSON.stringify(state.chartsAndTableViewsConfigs.categorySalesBarChart));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    categorySalesBarChart: {
                        ...state.chartsAndTableViewsConfigs.categorySalesBarChart,
                        activeDimention: action.activeDimention
                    }
                },
            };
        }

        case 'SET_CATEGORYSALESTABLEVIEWCONFIG': {
            Storage.setString('appState.chartsAndTableViewsConfigs.categorySalesTableView', JSON.stringify(action.categorySalesTableView));
            return {
                ...state,
                chartsAndTableViewsConfigs: {
                    ...state.chartsAndTableViewsConfigs,
                    categorySalesTableView: action.categorySalesTableView
                },
            };
        }
        default:
            return state;
    }
}

//hack to use this store outside of components
export let viewsState = initialState;
const reducerWrapper = (state, action) => {
    viewsState = reducer(state, action);
    return viewsState;
};

const ViewsContext = React.createContext();
export default ViewsContext;

export function ViewsContextProvider(props) {
    const [viewsState, dispatch] = React.useReducer(reducerWrapper, loadState());
    const setHourlySalesCumuToggleState = (hourlySalesCumuToggleState) => {
        dispatch({
            type: 'SET_SALESCUMULINECHARTTOGGLESTATE',
            hourlySalesCumuToggleState: hourlySalesCumuToggleState
        });
    };

    const setHourlySalesCumuLineChartConfig = (activeDimention) => {
        dispatch({
            type: 'SET_SALESCUMULINECHARTCONFIG',
            activeDimention: activeDimention
        });
    };

    const setHourlySalesCumuTableViewConfig = (hourlySalesCumuTableView) => {
        dispatch({
            type: 'SET_SALESCUMUTABLEVIEWCONFIG',
            hourlySalesCumuTableView: hourlySalesCumuTableView
        });
    };

    const setHourlySalesToggleState = (hourlySalesToggleState) => {
        dispatch({
            type: 'SET_SALESBARCHARTTOGGLESTATE',
            hourlySalesToggleState: hourlySalesToggleState
        });
    };

    const setHourlySalesBarChartConfig = (activeDimention) => {
        dispatch({
            type: 'SET_SALESBARCHARTCONFIG',
            activeDimention: activeDimention
        });
    };

    const setHourlySalesTableViewConfig = (hourlySalesTableView) => {
        dispatch({
            type: 'SET_SALESTABLEVIEWCONFIG',
            hourlySalesTableView: hourlySalesTableView
        });
    };

    const setHourlyLaborToggleState = (hourlyLaborToggleState) => {
        dispatch({
            type: 'SET_LABORBARCHARTTOGGLESTATE',
            hourlyLaborToggleState: hourlyLaborToggleState
        });
    };

    const setHourlyLaborBarChartConfig = (activeDimention) => {
        dispatch({
            type: 'SET_LABORBARCHARTCONFIG',
            activeDimention: activeDimention
        });
    };

    const setHourlyLaborTableViewConfig = (hourlyLaborTableView) => {
        dispatch({
            type: 'SET_LABORTABLEVIEWCONFIG',
            hourlyLaborTableView: hourlyLaborTableView
        });
    };
    const setHourlyLaborCumuToggleState = (hourlyLaborCumuToggleState) => {
        dispatch({
            type: 'SET_LABORCUMULINECHARTTOGGLESTATE',
            hourlyLaborCumuToggleState: hourlyLaborCumuToggleState
        });
    };
    const setHourlyLaborCumuLineChartConfig = (activeDimention) => {
        dispatch({
            type: 'SET_LABORCUMULINECHARTCONFIG',
            activeDimention: activeDimention
        });
    };
    const setHourlyLaborCumuTableViewConfig = (hourlyLaborCumuTableView) => {
        dispatch({
            type: 'SET_LABORCUMUTABLEVIEWCONFIG',
            hourlyLaborCumuTableView: hourlyLaborCumuTableView
        });
    };
    const setCostCenterToggleState = (costCenterToggleState) => {
        dispatch({
            type: 'SET_COSTCENTERBARCHARTTOGGLESTATE',
            costCenterToggleState: costCenterToggleState
        });
    };

    const setCostCenterBarChartConfig = (activeDimention) => {
        dispatch({
            type: 'SET_COSTCENTERBARCHARTCONFIG',
            activeDimention: activeDimention
        });
    };

    const setCostCenterTableViewConfig = (costCenterTableView) => {
        dispatch({
            type: 'SET_COSTCENTERTABLEVIEWCONFIG',
            costCenterTableView: costCenterTableView
        });
    };
    const setCategorySalesToggleState = (categorySalesToggleState) => {
        dispatch({
            type: 'SET_CATEGORYSALESBARCHARTTOGGLESTATE',
            categorySalesToggleState: categorySalesToggleState
        });
    };

    const setCategorySalesBarChartConfig = (activeDimention) => {
        dispatch({
            type: 'SET_CATEGORYSALESBARCHARTCONFIG',
            activeDimention: activeDimention
        });
    };

    const setCategorySalesTableViewConfig = (categorySalesTableView) => {
        dispatch({
            type: 'SET_CATEGORYSALESTABLEVIEWCONFIG',
            categorySalesTableView: categorySalesTableView
        });
    };
    return (
        <ViewsContext.Provider value={{
            viewsState, setHourlySalesCumuLineChartConfig, setHourlySalesCumuTableViewConfig, setHourlySalesCumuToggleState,
            setHourlySalesBarChartConfig, setHourlySalesTableViewConfig, setHourlySalesToggleState, setHourlyLaborBarChartConfig,
            setHourlyLaborTableViewConfig, setHourlyLaborToggleState, setHourlyLaborCumuLineChartConfig, setHourlyLaborCumuTableViewConfig,
            setHourlyLaborCumuToggleState, setCostCenterBarChartConfig, setCostCenterTableViewConfig, setCostCenterToggleState,
            setCategorySalesBarChartConfig, setCategorySalesTableViewConfig, setCategorySalesToggleState
        }}>
            {props.children}
        </ViewsContext.Provider>
    );

}




